import "./hb-about.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

export default (user) => html`
    <div
        id="hb-about"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        Privacy Safeguards
                    </h3>
                    <button
                        type="button"
                        class="${isPopup
                            ? "hidden"
                            : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="hb-about">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">Close</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div
                    id="hb-about-cam"
                    class="p-4 md:p-5 my-3 space-y-4 text-base leading-[2] text-gray-900 dark:text-white">
                    <div id="accordion-collapse" data-accordion="collapse">
                        <h2 id="accordion-collapse-heading-1">
                            <button
                                type="button"
                                class="bg-gray-600 flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
                                data-accordion-target="#accordion-collapse-body-1"
                                aria-expanded="false"
                                aria-controls="accordion-collapse-body-1">
                                <span>End-to-end Encryption</span>
                                <svg
                                    data-accordion-icon
                                    class="w-3 h-3 rotate-180 shrink-0"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 10 6">
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5 5 1 1 5" />
                                </svg>
                            </button>
                        </h2>
                        <div
                            id="accordion-collapse-body-1"
                            class="hidden"
                            aria-labelledby="accordion-collapse-heading-1">
                            <div
                                class="p-5 border border-b-0 border-gray-200 dark:border-gray-700 dark:bg-gray-900">
                                <p
                                    class="mb-2 text-gray-500 dark:text-gray-400">
                                    industry-standard RSA 2040-bit keys
                                </p>
                                <p class="text-gray-500 dark:text-gray-400">
                                    Check out this guide to learn how to
                                    <a
                                        href="/docs/getting-started/introduction/"
                                        class="text-blue-600 dark:text-blue-500 hover:underline"
                                        >get started</a
                                    >
                                    and start developing websites even faster
                                    with components on top of Tailwind CSS.
                                </p>
                            </div>
                        </div>
                        <h2 id="accordion-collapse-heading-2">
                            <button
                                type="button"
                                class="bg-gray-600 flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
                                data-accordion-target="#accordion-collapse-body-2"
                                aria-expanded="false"
                                aria-controls="accordion-collapse-body-2">
                                <span>Digital Signature</span>
                                <svg
                                    data-accordion-icon
                                    class="w-3 h-3 rotate-180 shrink-0"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 10 6">
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5 5 1 1 5" />
                                </svg>
                            </button>
                        </h2>
                        <div
                            id="accordion-collapse-body-2"
                            class="hidden"
                            aria-labelledby="accordion-collapse-heading-2">
                            <div
                                class="p-5 border border-b-0 border-gray-200 dark:border-gray-700">
                                <p
                                    class="mb-2 text-gray-500 dark:text-gray-400">
                                    Flowbite is first conceptualized and
                                    designed using the Figma software so
                                    everything you see in the library has a
                                    design equivalent in our Figma file.
                                </p>
                                <p class="text-gray-500 dark:text-gray-400">
                                    Check out the
                                    <a
                                        href="https://flowbite.com/figma/"
                                        class="text-blue-600 dark:text-blue-500 hover:underline"
                                        >Figma design system</a
                                    >
                                    based on the utility classes from Tailwind
                                    CSS and components from Flowbite.
                                </p>
                            </div>
                        </div>
                        <h2 id="accordion-collapse-heading-3">
                            <button
                                type="button"
                                class="bg-gray-600 rounded-b-xl flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
                                data-accordion-target="#accordion-collapse-body-3"
                                aria-expanded="false"
                                aria-controls="accordion-collapse-body-3">
                                <span>Security Audit</span>
                                <svg
                                    data-accordion-icon
                                    class="w-3 h-3 rotate-180 shrink-0"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 10 6">
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5 5 1 1 5" />
                                </svg>
                            </button>
                        </h2>
                        <div
                            id="accordion-collapse-body-3"
                            class="hidden"
                            aria-labelledby="accordion-collapse-heading-3">
                            <div
                                class="p-5 border border-t-0 border-gray-200 dark:border-gray-700">
                                <p
                                    class="mb-2 text-gray-500 dark:text-gray-400">
                                    OWASP ASVS L3 Security Audit, cryptographic
                                    audit, GDPR/CCPA Compliance for Privacy and
                                    Data Protection
                                </p>
                                <p
                                    class="mb-2 text-gray-500 dark:text-gray-400">
                                    ???
                                </p>
                                <p
                                    class="mb-2 text-gray-500 dark:text-gray-400">
                                    Learn more about these technologies:
                                </p>
                                <ul
                                    class="ps-5 text-gray-500 list-disc dark:text-gray-400">
                                    <li>
                                        <a
                                            href="https://flowbite.com/pro/"
                                            class="text-blue-600 dark:text-blue-500 hover:underline"
                                            >Flowbite Pro</a
                                        >
                                    </li>
                                    <li>
                                        <a
                                            href="https://tailwindui.com/"
                                            rel="nofollow"
                                            class="text-blue-600 dark:text-blue-500 hover:underline"
                                            >Tailwind UI</a
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Modal footer -->
                <div
                    class="text-sm font-medium text-gray-900 dark:text-gray-300 flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <input
                        type="checkbox"
                        class="w-8 h-8 mr-5 outline-0"
                        checked
                        disabled />
                    By using HeartBank® you accept our security safeguards.
                </div>
            </div>
        </div>
    </div>
`;
